
const logLevel = 2;
const logger = {
  debug(msg) {
    if (logLevel <= 1) {
      console.log(msg);
    }
  },
  info(msg) {
    if (logLevel <= 2) {
      console.log(msg);
    }
  },
  warn(msg) {
    if (logLevel <= 3) {
      console.warn(msg);
    }
  },
  error(msg) {
    if (logLevel <= 4) {
      console.error(msg);
    }
  },
};
// 原始window事件
const originalFunc = {
  setTimeout: window.setTimeout,
  clearTimeout: window.clearTimeout,
  setInterval: window.setInterval,
  clearInterval: window.clearInterval,
  addEventListener: window.addEventListener,
  removeEventListener: window.removeEventListener,
};

// 模块运行前的window环境
const curContext = {
  window: {},
  timeout: {},
  interval: {},
  eventListener: {},
};

export function saveGlobal() {
  for (const k in curContext) {
    curContext[k] = {};
  }

  window.setInterval = function () {
    const id = originalFunc.setInterval.apply(window, arguments);
    curContext.interval[id] = true;
    return id;
  };
  // window.setTimeout = function(){
  //     //return st(fn,delay)
  //     let id = originalFunc.setTimeout.apply(window,arguments);
  //     curContext["timeout"][id]=true
  // }
  // window.clearTimeout = function(id){
  //     originalFunc.clearTimeout.apply(window,arguments);
  //     curContext["timeout"][id]=false
  // }
  window.clearInterval = function (id) {
    curContext.interval[id] = false;
    return originalFunc.clearInterval.apply(window, arguments);
  };

  window.addEventListener = function (name, func) {
    if (curContext.eventListener[name]) {
      curContext.eventListener[name].push(func);
    } else {
      curContext.eventListener[name] = [func];
    }
    return originalFunc.addEventListener.apply(window, arguments);
  };
  window.removeEventListener = function (name, func) {
    if (curContext.eventListener[name]) {
      for (let i = curContext.eventListener[name].length - 1; i > -1; i--) {
        if (curContext.eventListener[name][i] == func) {
          curContext.eventListener[name].splice(i, 1);
        }
      }
    }
    return originalFunc.removeEventListener.apply(window, arguments);
  };

  // property
  for (const a in window) {
    curContext.window[a] = window[a];
  }
  logger.debug('global saved');
}

export function resetAppGlobal(g) {
  logger.debug('resetAppGlobal:');
  for (const a in g) {
    try {
      logger.debug(a);
      window[a] = g[a];
    } catch (ex) {
      logger.debug(`resetAppGlobal,为只读：${a}`);
    }
  }
  logger.debug('resetAppGlobal ed');
}

export function resetGlobal() {
  logger.debug('resetGlobal:');
  for (const a in window) {
    if (a in curContext.window) { // 两边都存在的属性
      if (window[a] != curContext.window[a]) {
        logger.debug(`perhaps change:${a}`);// 还原
        try{
          window[a] = curContext.window[a];
        }
        catch(ex){
          console.log(a+':reset error.'+ex)
        }
      }
      //
    } else {
      logger.debug(a);
      // window[a] = undefined
      try {
        const delResult = delete window[a];
        if (!delResult) {
          logger.warn(`你的全局变量没有delete清理：${a}`);
        } else {
          window[a] = undefined;
        }
      } catch (ex) {
        //window[a] = undefined;
        logger.warn(`你的全局变量delete抽错为只读：${a}`);
      }
    }
  }

  // reset orginal function
  for (const f in originalFunc) {
    window[f] = originalFunc[f];
  }

  // 定时器
  for (const id in curContext.timeout) {
    if (curContext.timeout[id]) {
      logger.debug(`clearTimeout:${id}`);
      window.clearTimeout(id);
    }
  }
  for (const id in curContext.interval) {
    if (curContext.interval[id]) {
      logger.debug(`clearInterval:${id}`);
      window.clearInterval(id);
    }
  }
  // 事件
  for (const name in curContext.eventListener) {
    for (const func of curContext.eventListener[name]) {
      logger.debug(`removeEventListener:${name}`);
      window.removeEventListener(name, func);
    }
  }
  logger.debug('global reseted');
}
